import React from "react";
import { Button, Typography, Modal, Box } from "@mui/material";
import { SingleInputField } from "../../../components";
import { walletData } from "../../../assets/lib/wallet";
import { CircularLoader } from "../../../components/widgets/CircularLoader";

const Layout = (props) => {
  const {
    walletAmount,
    handle,
    getWalletInput,
    walletState,
    rechargeLoader,
    friendNumber,
    setFriendNumber,
    friendName,
    verifyStatus,
    verifyFriend,
    sendAmount,
    setSendAmount,
    sendMoney,
    transferLoader,
    transferMessage,
    fetchOffers,
    offers,
    offersModalOpen,
    setOffersModalOpen,
    applyOffer,
    verifyRecharge,
    rechargeStatusMessage,

     emailOptOut,
    handleNewsletterToggle,
    subscribeLoading,
  } = props;

  return (
    <>
      <Box
        sx={{
          p: 4,
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 3,
          fontFamily: "montserrat",
        }}
      >
        {rechargeLoader && <CircularLoader isPoistionAbsolute />}

        {/* Wallet Balance */}
        <Typography
          variant="h4"
          sx={{
            mt: 2,
            mb: 2,
            textAlign: "center",
            fontWeight: 600,
            color:
              walletAmount > 100
                ? "green"
                : walletAmount < 100
                ? "red"
                : "black",
          }}
        >
          Wallet Balance: ₹{walletAmount}
        </Typography>

        <Typography
          variant="body2"
          sx={{
            color: "#555",
            fontStyle: "italic",
            mt: "-5px",
            textAlign: "center",
          }}
        >
          A minimum balance of ₹100 is required for machine access.
        </Typography>

        {/* Recharge Input */}
        <Box sx={{ width: "30%", textAlign: "center" }}>
          <SingleInputField
            content={walletData.rechargeAmount}
            value={walletState.rechargeAmount}
            getInputData={getWalletInput}
            errorFields={[]}
            placeholder="Enter recharge amount"
          />
        </Box>

        {/* Recharge Buttons */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 1,
            alignItems: "flex-start",
          }}
        >
          <Box sx={{ display: "flex", gap: 1 }}>
            <Button
              variant="contained"
              onClick={handle}
              disabled={
                !walletState.rechargeAmount ||
                walletState.rechargeAmount <= 0
              }
              sx={{
                backgroundColor: "black",
                width: 120,
                marginLeft: "130px",
                color: "white",
                "&:hover": { backgroundColor: "black" },
                "&.Mui-disabled": {
                  backgroundColor: "#e0e0e0",
                  color: "#9e9e9e",
                },
              }}
            >
              Recharge
            </Button>

            <Button
              variant="contained"
              onClick={verifyRecharge}
              sx={{
                backgroundColor: "black",
                color: "white",
                "&:hover": { backgroundColor: "black" },
              }}
            >
              Refresh Wallet
            </Button>
          </Box>

          {/* Stagnant Warning Text */}
          <Box
            sx={{
              width: "100%",
              ml: 3,
            }}
          >
            <Typography
              sx={{
                color: "red",
                fontSize: 13,
              }}
            >
              In case of a failed recharge, please refresh your wallet before
              attempting another recharge.
            </Typography>
          </Box>

          {rechargeStatusMessage && (
            <Typography sx={{ mt: 1, color: "green" }}>
              {rechargeStatusMessage}
            </Typography>
          )}
        </Box>

        <Button
        variant="outlined"
        disabled={!emailOptOut || subscribeLoading}
        onClick={handleNewsletterToggle}
        sx={{
          mt: 1,
          borderColor: "black",
          color: "black",
          "&:hover": {
            backgroundColor: emailOptOut ? "#f5f5f5" : "transparent",
          },
          "&.Mui-disabled": {
            borderColor: "#ccc",
            color: "#999",
          },
        }}
      >
        {emailOptOut ? "Subscribe to Newsletter" : "Subscribed"}
      </Button>


        {/* Offers Modal */}
        <Modal
          open={offersModalOpen}
          onClose={() => setOffersModalOpen(false)}
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: 400,
              bgcolor: "white",
              boxShadow: 24,
              p: 4,
              borderRadius: 2,
              fontFamily: "montserrat",
            }}
          >
            <Typography variant="h6" gutterBottom>
              Available Offers
            </Typography>

            {offers.length === 0 ? (
              <Typography>No offers available</Typography>
            ) : (
              offers.map((offer) => (
                <Box
                  key={offer.id}
                  sx={{
                    border: "1px solid #ddd",
                    borderRadius: 2,
                    p: 1.5,
                    mb: 1,
                  }}
                >
                  <Typography>
                    Recharge: ₹{offer.rechargeAmount} | Wallet: ₹
                    {offer.walletAmount}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Expires on: {offer.endDate}
                  </Typography>
                  <Button
                    size="small"
                    onClick={() => applyOffer(offer)}
                    sx={{
                      mt: 1,
                      backgroundColor: "black",
                      color: "white",
                      "&:hover": { backgroundColor: "black" },
                    }}
                  >
                    Apply Offer
                  </Button>
                </Box>
              ))
            )}
          </Box>
        </Modal>
      </Box>
    </>
  );
};

export default Layout;
